<template>
  <Teleport
    to="#alerts"
    v-if="modelValue">
    <div
      class="clipboard-alert"
      key="alert">
      <p class="h1 clipboard-content px-2">
        <slot>Success</slot>
      </p>
    </div>
  </Teleport>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      required: true,
    },
    timer: {
      type: Number,
      default: 1500,
    },
  },
  emits: ['update:modelValue'],

  watch: {
    modelValue: {
      immediate: true,
      handler: function (show) {
        if (show) {
          this.showMessage();
        }
      },
    },
  },

  methods: {
    showMessage() {
      setTimeout(() => this.hideMessage(), this.timer);
    },

    hideMessage() {
      this.$emit('update:modelValue', false);
    },
  },
};
</script>
